import { BaseModulePublicApi } from "../../base/BaseModulePublicApi";

export class PublicTicketSectionsSeatedApi extends BaseModulePublicApi {
  basePath = 'tickets_sections';

  constructor(domain: string, ticket_section_id: string, token?: string) {
    super(domain, token);
    this.basePath = `${this.basePath}/${ticket_section_id}/seated`;
  }
};
